export const defaultStyle = {
    wrapper:
        "z-[20] py-[30px] fixed left-0 right-0 bottom-0 bg-burgundy transition-all duration-300 ease-in-out overflow-hidden",
    content: "section-wrapper flex flex-col md:flex-row gap-4 justify-start md:justify-between",
    copyWrapper: "flex flex-col items-start justify-start gap-4 pl-0 md:pl-12 lg:pl-0",
    title: "text-white subtitle-medium title-shadow md:subtitle-big",
    description: "text-white body-s",
    ctaWrapper: "flex items-center justify-center md:items-start md:justify-between gap-4 flex-wrap sm:flex-nowrap",
}
